<template>
    <Transition name="modal-fade">
        <div v-if="showWarning" class="modal-overlay" @click.self="onMask">
            <div class="modal-card">
                <div class="modal-header">
                    <h3 class="header-title">浏览器兼容提示</h3>
                    <button class="modal-close" @click="dismiss" aria-label="关闭">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"/>
                            <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                    </button>
                </div>

                <!-- 文案 -->
                <p class="modal-msg">
                    您的浏览器可能不支持或支持不佳，请从以下浏览器中选择最新的版本访问，以获得最佳体验。
                </p>

                <!-- 浏览器列表 -->
                <div class="browser-list">
                    <div v-for="item in supportList" :key="item.key" class="browser-item">
                        <img :src="item.icon" :alt="item.name" class="browser-img" />
                        <span class="browser-name">{{ item.name }}</span>
                    </div>
                </div>

            </div>
        </div>
    </Transition>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { isBrowserSupported } from '@/service/utils/browserCheck'

import chromeIcon from '@/assets/browser-icons/chrome.svg'
import edgeIcon from '@/assets/browser-icons/edge.svg'
import safariIcon from '@/assets/browser-icons/safari.svg'
import qqIcon from '@/assets/browser-icons/qq.png'
import m360Icon from '@/assets/browser-icons/360.png'

const supportList = [
    { key: 'chrome', name: 'Chrome', icon: chromeIcon },
    { key: 'edge', name: 'Edge', icon: edgeIcon },
    { key: 'safari', name: 'Safari', icon: safariIcon },
    { key: '360', name: '360浏览器', icon: m360Icon },
    { key: 'qq', name: 'QQ浏览器', icon: qqIcon },
]

const BROWSER_WARNING_KEY = 'browser_warning_dismissed'

// sessionStorage：同一标签页刷新后不再提示，关闭标签页重新打开后会再次提示
// 仅在不支持的浏览器 且 当前标签页未关闭过提示时才弹出
const showWarning = ref(!isBrowserSupported() && sessionStorage.getItem(BROWSER_WARNING_KEY) !== '1')

const dismiss = () => {
    showWarning.value = false
    sessionStorage.setItem(BROWSER_WARNING_KEY, '1')
}
const onMask = () => {}
</script>

<style lang="scss" scoped>
.modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(15, 23, 42, 0.4);
    backdrop-filter: blur(8px);
}

.modal-card {
    position: relative;
    width: 640px;
    max-width: 100%;
    padding: 32px 32px 26px;
    background: #fff;
    border-radius: 20px;
    box-shadow:
        0 2px 6px rgba(0, 0, 0, 0.04),
        0 20px 60px rgba(0, 0, 0, 0.18);
    text-align: center;
}

.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.header-title {
    margin: 0;
    font-size: 17px;
    font-weight: 700;
    color: #0f172a;
}

.modal-close {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 8px;
    background: transparent;
    color: #94a3b8;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s, color 0.15s;

    svg {
        width: 18px;
        height: 18px;
    }

    &:hover {
        background: #f1f5f9;
        color: #475569;
    }
}

.modal-msg {
    margin: 0 0 26px;
    font-size: 13.5px;
    color: #64748b;
    line-height: 1.7;
    padding: 0 6px;
    text-align: left;
    white-space: nowrap;
}

.browser-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    margin-bottom: 26px;
}

.browser-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 16px 8px 12px;
    border-radius: 14px;
    background: #f8fafc;
    border: 1px solid #f1f5f9;
    transition: background 0.15s, box-shadow 0.15s;

    &:hover {
        background: #f1f5f9;
        box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    }
}

.browser-img {
    width: 48px;
    height: 48px;
    object-fit: contain;
}

.browser-name {
    font-size: 12px;
    font-weight: 500;
    color: #475569;
}

.modal-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    padding: 0 36px;
    border: none;
    border-radius: 10px;
    background: #1e293b;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;

    &:hover { background: #0f172a; }
    &:active { transform: scale(0.97); }
}

/* 过渡 */
.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);

    .modal-card {
        transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    }
}

.modal-fade-enter-from,
.modal-fade-leave-to {
    opacity: 0;

    .modal-card {
        transform: scale(0.92);
        opacity: 0;
    }
}
</style>
